var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 11V5H14.9995V11H12.9995ZM12.9995 15V13H14.9995V15H12.9995ZM8.99955 11V3C8.99955 1.3 7.69955 0 5.99955 0C4.29955 0 2.99955 1.3 2.99955 3V11C0.799548 12.7 0.299549 15.8 1.99955 18C3.69955 20.2 6.79955 20.7 8.99955 19C11.1995 17.3 11.6995 14.2 9.99955 12C9.69955 11.6 9.39955 11.3 8.99955 11ZM5.99955 2C6.59955 2 6.99955 2.4 6.99955 3V6H4.99955V3C4.99955 2.4 5.39955 2 5.99955 2Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.cb3ea222bbfa9daee70dbc9d491d945e.svg";
export { ForwardRef as ReactComponent };